import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/phone",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.6666 0.666748H5.33325C4.22659 0.666748 3.33325 1.56008 3.33325 2.66675V13.3334C3.33325 14.4401 4.22659 15.3334 5.33325 15.3334H10.6666C11.7733 15.3334 12.6666 14.4401 12.6666 13.3334V2.66675C12.6666 1.56008 11.7733 0.666748 10.6666 0.666748ZM9.33325 14.0001H6.66659V13.3334H9.33325V14.0001ZM11.4999 12.0001H4.49992V2.66675H11.4999V12.0001Z",
			fill: "#959595"
		})
	})
});
export default SvgIconPhone;
